import { useEffect } from "react";
import "./CustomToast.css"; // Import the CSS file

const CustomToast = ({ message, onClose, duration = 30000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  if (!message) return null;

  return <div className="CustomToast">{message}</div>;
};

export default CustomToast;
